import React from 'react';

const RatingScale = ({ value, onChange, count = 11 }) => {
  return (
    <div className="nps-scores">
      {[...Array(count)].map((_, index) => (
        <button
          key={index}
          className={`score-button ${value === index ? 'selected' : ''}`}
          onClick={() => onChange(index)}
        >
          {index}
        </button>
      ))}
    </div>
  );
};

export default RatingScale;